import { render } from "./TestEdit.html?vue&type=template&id=7aa10cb4&scoped=true&ts=true"
import script from "./TestEdit.ts?vue&type=script&lang=ts"
export * from "./TestEdit.ts?vue&type=script&lang=ts"

import "./TestEdit.css?vue&type=style&index=0&id=7aa10cb4&scoped=true&lang=css"

import exportComponent from "/home/dev/deployment/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7aa10cb4"]])

export default __exports__